// Elements
import Container from 'react-bootstrap/Container'
import { CountryCodes } from '../Helper/constants';

function TopBar(props) {
    const contact = props.clinic.contact;
    const has_mobile = contact.mobile.length > 0;
    const has_email = contact.email.length > 0;
    const social_media = props.clinic.social_media || {};
    const socials = [
        { key: "facebook", icon: "fa-facebook-f", label: "Facebook" },
        { key: "instagram", icon: "fa-instagram", label: "Instagram" },
        { key: "youtube", icon: "fa-youtube", label: "YouTube" },
    ].filter(social => social.key in social_media);

    return (
    <div className="top-bar">
        <Container>
            <div className="band-row top-bar__inner">
                <ul className="top-bar__info">
                    {has_mobile ?
                    <li>
                        <i className="fa-solid fa-phone"></i>
                        <a href={`tel:${CountryCodes.india}${contact.mobile[0]}`}>{CountryCodes.india}-{contact.mobile[0]}</a>
                    </li> : null}
                    {has_email ?
                    <li className="d-none d-md-flex">
                        <i className="fa-regular fa-envelope"></i>
                        <a href={`mailto:${contact.email}`}>{contact.email}</a>
                    </li> : null}
                </ul>
                {socials.length > 0 ?
                <ul className="top-bar__social">
                    {socials.map(social => (
                        <li key={social.key}>
                            <a href={social_media[social.key]} target="_blank" rel="noopener noreferrer" aria-label={social.label}>
                                <i className={`fa-brands ${social.icon}`}></i>
                            </a>
                        </li>
                    ))}
                </ul> : null}
            </div>
        </Container>
    </div>
    );
  }
  
  export default TopBar;
